import React, {useCallback} from "react";
import Memo from "../../../../../components/hoc/Memo";
import {Form, Input} from "antd";
import FormControls from "../../../../../components/form/FormControls/FormControls";
import RichTextEditor, {BaseKit} from 'reactjs-tiptap-editor';

import 'reactjs-tiptap-editor/style.css';
import {GuideFormFields} from "../../../../../types/formFieldTypes";
import {Bold} from "reactjs-tiptap-editor/lib/Bold";
import {Italic} from "reactjs-tiptap-editor/lib/Italic";
import {TextAlign} from "reactjs-tiptap-editor/lib/TextAlign";
import SlashCommand from "reactjs-tiptap-editor/lib/SlashCommand";
import Table from "reactjs-tiptap-editor/lib/Table";
import { History } from 'reactjs-tiptap-editor/lib/History';
import {FontSize} from "reactjs-tiptap-editor/lib/FontSize";
import {Strike} from "reactjs-tiptap-editor/lib/Strike";
import {Heading} from "reactjs-tiptap-editor/lib/Heading";
import {Color} from "reactjs-tiptap-editor/lib/Color";
import {BulletList} from "reactjs-tiptap-editor/lib/BulletList";
import {OrderedList} from "reactjs-tiptap-editor/lib/OrderedList";
import {Highlight} from "reactjs-tiptap-editor/lib/Highlight";
import {Blockquote} from "reactjs-tiptap-editor/lib/Blockquote";
import {HorizontalRule} from "reactjs-tiptap-editor/lib/HorizontalRule";
import {LineHeight} from "reactjs-tiptap-editor/lib/LineHeight";
import {Link} from "reactjs-tiptap-editor/lib/Link";
import {ImportWord} from "reactjs-tiptap-editor/lib/ImportWord";
import {ColumnActionButton} from "reactjs-tiptap-editor/lib/MultiColumn";


type GuideFormInputsProps = {
    handleChange: (e: React.ChangeEvent<HTMLInputElement>) => void
    clearForm?: () => void
    resetChanges?: () => void
    submitForm: () => void
    values: GuideFormFields
}

const extensions = [
    BaseKit.configure({
        // Show placeholder
        placeholder: {
            showOnlyCurrent: true,
        },

        // Character count
        characterCount: {
            limit: 50_000,
        },
    }),
    History,
    Heading.configure({
        spacer: true,
    }),
    FontSize,
    Bold.configure({
        spacer: true,
    }),
    Italic,
    Strike,
    TextAlign,
    Color.configure({
        spacer: true,
    }),
    Highlight,
    LineHeight,
    BulletList.configure({
        spacer: true,
    }),
    OrderedList,
    SlashCommand,
    Table,
    ColumnActionButton,
    Blockquote,
    HorizontalRule,
    Link,
    ImportWord,
    // Import Extensions Here
];

export const GuideFormInputs: React.FC<React.PropsWithChildren<GuideFormInputsProps>> = (props) => {
    const {
        handleChange, clearForm, submitForm,
        resetChanges, values
    } = props

    const handleChangeRichText = useCallback((value: string) => {
        console.log('change', value)
        handleChange({target: {value: value, name: 'text'}} as React.ChangeEvent<HTMLInputElement>);
    }, [handleChange])

    return (
        <>
            <Memo hdl={handleChange}>
                <Form.Item
                    name="name"
                    label="Название"
                    className="uif-ant-form-item"
                >
                    <Input onInput={handleChange} />
                </Form.Item>
            </Memo>

            <Memo hdl={handleChange}>
                <Form.Item
                    name="path"
                    label="Путь"
                    className="uif-ant-form-item"
                >
                    <Input onInput={handleChange} />
                </Form.Item>
            </Memo>

            <Memo hdl={handleChangeRichText}>
                <Form.Item
                    name="text"
                    label="Текст"
                    className="uif-ant-form-item"
                >
                    <RichTextEditor
                        output='html'
                        dark={false}
                        content={values.text}
                        onChangeContent={handleChangeRichText}
                        extensions={extensions}
                        toolbar={{
                            render: (props, toolbarItems, dom, containerDom) => {
                                return containerDom(dom)
                            }
                        }}
                    />
                </Form.Item>
            </Memo>

            <FormControls
                submitForm={submitForm}
                resetChanges={resetChanges}
                clearForm={clearForm}
            />
        </>
    )
}

export default GuideFormInputs